import { Modal, Form, Button, Rate, Typography, message } from "antd";
import { useSelector } from "react-redux";
import { Post } from "../../config/api/post";
import { RATING } from "../../config/constants/api";
import "./style.css";
import swal from "sweetalert";

// const { TextArea } = Input;
const { Title,  } = Typography;
const ReviewModal = ({ open, handleOk, handleCancel, firstName, lastName, user }) => {
  const [form] = Form.useForm();
  const token = useSelector((state) => state?.user?.userToken);
  const userData = useSelector((state) => state?.user?.userData);

  const onFinish = async (values) => {
    try {
      const data = {
        chauffeur : userData._id,
        rating: values.rating,
        isChauffeur: true,
        user: user,
      };
      const response = await Post(RATING.giveRating, data, token);
      if (response?.status) {
        swal("System Alert", response?.message, "success");
        handleOk();
      } else {
        message.error(response?.message || "Failed to add review");
      }
    } catch (error) {
      console.error("Error adding review:", error);
      message.error("An unexpected error occurred.");
    }
  };

  return (
    <Modal
      centered
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      title="Rate Your Experience"
      footer={null}
      className="StyledModal"
      style={{
        left: 0,
        right: 0,
        marginLeft: "auto",
        marginRight: "auto",
        textAlign: "center",
      }}
    >
      <Form form={form} onFinish={onFinish} layout="vertical">
        {/* <Typography>{`How was your experience with ${firstName} ${lastName}`}</Typography> */}
        <Title level={4}>
          How was Your Experience with {firstName} {lastName}?
        </Title>
        <Form.Item
          name="rating"
          rules={[{ required: true, message: "Please rate your experience" }]}
        >
          <Rate />
        </Form.Item>
        <Form.Item>
          <Button type="" htmlType="submit" className="btn web-btn px-5">
            Submit Now
          </Button>
        </Form.Item>
        <Form.Item>
          <Button
            type="link"
            style={{ textDecoration: "underline" }}
            onClick={handleCancel}
          >
            Skip
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ReviewModal;
